
<template>
  <el-table :data="tableData"
            ref="multipleTable"
            highlight-current-row
            @row-dblclick="rowDblclick"
            v-loading="loading"
            :element-loading-text="$t('memberlist.loading')"
            height=" calc(100% - 55px)"
            class="tb">
    <el-table-column v-if="isshow"
                     type="selection"
                     align="center"
                     fixed></el-table-column>
    <el-table-column v-for="(th, key) in tableHeader"
                     :key="key"
                     :prop="th.prop"
                     :label="th.label"
                     :fixed="th.fixed"
                     :width="th.width"
                     :min-width="th.minWidth"
                     align="left">
      <template slot-scope="scope">
        <div v-if="th.oper">
          <el-button v-for="(o, key) in th.oper"
                     :key="key"
                     @click="o.clickFun(scope.row)"
                     :type="o.style"
                     :icon="o.icon"
                     size="small">{{o.name}}
          </el-button>
        </div>
        <div v-else>
          <span v-if="!th.formatData"
                :title="th.title? scope.row[th.title]: ''">{{ scope.row[th.prop] }}</span>
          <span v-else>
            <span v-html="th.formatData(scope.row[th.prop])"></span>
          </span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "index",
  props: {
    tableData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    rowDblclick: {
      type: Function,
      default: () => {}
    },
    tableHeader: {
      type: Array,
      default: function () {
        return [];
      }
    },
    tabheight: {
      type: String,
      default: "100%"
    },
    loading: {
      type: Boolean,
      default: false
    },
    isshow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getmydata() {
      this.$emit("func");
    }
  }
};
</script>
<style>
/* 处理底部的1px的边框 */
.el-table__fixed-right::before,
.el-table__fixed::before {
  display: none;
}
.el-table::before {
  display: none;
}
</style>
<style scoped>
.el-button--small {
  padding: 5px 10px;
  margin: 5px 5px;
}
.tb {
  border: 1px solid #ebeef5;
  /* border-bottom: none; */
}
</style>
